import { formatISOBasic } from '../date/DateFormatter';

const Service = window.tnew.lib.ajax.Service;

const relativeUrl = 'api/products/productionseasons';
let additionalApiData = {};

function setAdditionalApiData(data) {
  additionalApiData = data;
}

async function post(data_) {
  const service = new Service();
  const data = Object.assign({}, additionalApiData, data_);

  data.startDate = formatISOBasic(data.startDate);
  data.endDate = formatISOBasic(data.endDate);

  const productions = await service.post(relativeUrl, data);

  return {
    productions,
    requestData: data,
  };
}


export default {
  setAdditionalApiData,
  post,
};



// WEBPACK FOOTER //
// ./V7/events/listing/api/EventListingService.js